/* eslint-disable */
export default {
  _bpreplayregular: 'bpreplayregular',
  _bpreplaybold: 'bpreplaybold',
}